import { ReactComponent as BlueArrowRight } from './BlueArrowRight.svg';
import { ReactComponent as DevelopBehaviours } from './DevelopBehaviours.svg';
import { ReactComponent as Logo } from './Logo.svg';
import { ReactComponent as KeepTrackIcon } from './KeepTrackIcon.svg';
import { ReactComponent as BringCulture } from './BringCulture.svg';
import { ReactComponent as CrossIcon } from './CrossIcon.svg';
import { ReactComponent as GreenCheckIcon } from './GreenCheckIcon.svg';
import { ReactComponent as ArrowUpIcon } from './ArrowUpIcon.svg';
import { ReactComponent as ArrowDownIcon } from './ArrowDownIcon.svg';
import { ReactComponent as LoginSidebarImg } from '../img/loginBg.svg';
import { ReactComponent as WhiteLogo } from './WhiteLogo.svg';
import { ReactComponent as OneIcon } from './habitIcons/OneIcon.svg';
import { ReactComponent as TwoIcon } from './habitIcons/TwoIcon.svg';
import { ReactComponent as ThreeIcon } from './habitIcons/ThreeIcon.svg';
import { ReactComponent as FourIcon } from './habitIcons/FourIcon.svg';
import { ReactComponent as GreenCheckIcon2 } from './GreenCheckIcon2.svg';
import { ReactComponent as BlueCheckedIcon } from './BlueCheckedIcon.svg';
import { ReactComponent as PlusIcon } from './PlusIcon.svg';
import { ReactComponent as PositiveImpactIcon } from './PositiveImpactIcon.svg';
import { ReactComponent as KeepGoingBlueIcon } from './KeepGoingBlueIcon.svg';
import { ReactComponent as KeepGoingGreyIcon } from './KeepGoingGreyIcon.svg';
import { ReactComponent as CheckedBlueIconCircle } from './CheckedBlueIconCircle.svg';
import { ReactComponent as NotCheckedBlueIcon } from './NotCheckedBlueIcon.svg';
import { ReactComponent as KeepDoingSmallIcon } from './KeepDoingSmallIcon.svg';
import { ReactComponent as LeaderboardIcon } from './LeaderboardIcon.svg';
import { ReactComponent as TreeDotsIcon } from './TreeDotsIcon.svg';
import { ReactComponent as CheckedGreenIconCircle } from './CheckedGreenIconCircle.svg';
import { ReactComponent as NotCheckedGrayIconCircle } from './NotCheckedGrayIconCircle.svg';
import { ReactComponent as GreenUpIcon } from './GreenUpIcon.svg';
import { ReactComponent as NeutralArrowIcon } from './NeutralArrowIcon.svg';
import { ReactComponent as GreyChartIcon } from './GreyChartIcon.svg';
import { ReactComponent as GreyCalendarIcon } from './GreyCalendarIcon.svg';
import { ReactComponent as NoTasksIcon } from './NoTasksIcon.svg';
import { ReactComponent as IconDown } from './IconDown.svg';
import { ReactComponent as QuickQuizIcon } from './QuickQuizIcon.svg';
import { ReactComponent as DailyReflectionIcon } from './DailyReflectionIcon.svg';
import { ReactComponent as PulseCheckIcon } from './PulseCheckIcon.svg';
import { ReactComponent as MythFactIcon } from './MythFactIcon.svg';
import { ReactComponent as BehaviourReversalIcon } from './BehaviourReversalIcon.svg';
import { ReactComponent as MiniLearningPromptIcon } from './MiniLearningPromptIcon.svg';
import { ReactComponent as PatternRecognitionIcon } from './PatternRecognition.svg';
import { ReactComponent as ScenarioIcon } from './ScenarioIcon.svg';
import { ReactComponent as ClockIcon } from './ClockIcon.svg';
import { ReactComponent as LogoutIcon } from './LogoutIcon.svg';
import { ReactComponent as ArrowRightIcon } from './ArrowRightIcon.svg';
import { ReactComponent as SummaryMoodIcon } from './SummaryMoodIcon.svg';
import { ReactComponent as SummaryAchievementsIcon } from './SummaryAchievementsIcon.svg';
import { ReactComponent as SummaryTeamIcon } from './SummaryTeamIcon.svg';
import { ReactComponent as GreenUpWithBGIcon } from './GreenUpWithBGIcon.svg';
import { ReactComponent as GreenIconsUpRight } from './GreenIconsUpRight.svg';
import { ReactComponent as RedDownWithBGIcon } from './RedDownWithBGIcon.svg';
import { ReactComponent as NeutralWithBGIcon } from './NeutralWithBGIcon.svg';
import { ReactComponent as Achievement1Icon } from './achievements/1.svg';
import { ReactComponent as Achievement2Icon } from './achievements/2.svg';
import { ReactComponent as Achievement3Icon } from './achievements/3.svg';
import { ReactComponent as Achievement4Icon } from './achievements/4.svg';
import { ReactComponent as ProgrammIcon1 } from './programmIcons/1.svg';
import { ReactComponent as ProgrammIcon2 } from './programmIcons/2.svg';
import { ReactComponent as ProgrammIcon3 } from './programmIcons/3.svg';
import { ReactComponent as NotCheckedGrayFullIconCircle } from './NotCheckedGrayFullIconCircle.svg';
import { ReactComponent as BlackArrowUp } from './BlackArrowUp.svg';
import { ReactComponent as BlackArrowDown } from './BlackArrowDown.svg';
import { ReactComponent as BlackArrowRight } from './BlackArrowRight.svg';

// Milestones badges
import { ReactComponent as MilestonesLevel1 } from './achievements/bages/milestones/level1.svg';
import { ReactComponent as MilestonesLevel2 } from './achievements/bages/milestones/level2.svg';
import { ReactComponent as MilestonesLevel3 } from './achievements/bages/milestones/level3.svg';
import { ReactComponent as MilestonesLevel4 } from './achievements/bages/milestones/level4.svg';

// Peers Endorsement badges
import { ReactComponent as PeersEndorsement1 } from './achievements/bages/peersEndorsement/1.svg';
import { ReactComponent as PeersEndorsement2 } from './achievements/bages/peersEndorsement/2.svg';
import { ReactComponent as PeersEndorsement3 } from './achievements/bages/peersEndorsement/3.svg';
import { ReactComponent as PeersEndorsement4 } from './achievements/bages/peersEndorsement/4.svg';
import { ReactComponent as PeersEndorsement5 } from './achievements/bages/peersEndorsement/5.svg';

// Streak badges
import { ReactComponent as Streak3 } from './achievements/bages/streak/3.svg';
import { ReactComponent as Streak5 } from './achievements/bages/streak/5.svg';
import { ReactComponent as Streak7 } from './achievements/bages/streak/7.svg';
import { ReactComponent as Streak10 } from './achievements/bages/streak/10.svg';
import { ReactComponent as Streak15 } from './achievements/bages/streak/15.svg';

// Habit Development badges
import { ReactComponent as HabitDev2 } from './achievements/bages/habitDevelopment/2.svg';
import { ReactComponent as HabitDev5 } from './achievements/bages/habitDevelopment/5.svg';
import { ReactComponent as HabitDev10 } from './achievements/bages/habitDevelopment/10.svg';
import { ReactComponent as HabitDev15 } from './achievements/bages/habitDevelopment/15.svg';
import { ReactComponent as HabitDev30 } from './achievements/bages/habitDevelopment/30.svg';

// Evaluate Habit badges
import { ReactComponent as EvaluateHabit1 } from './achievements/bages/evaluateHabit/1.svg';
import { ReactComponent as EvaluateHabit2 } from './achievements/bages/evaluateHabit/2.svg';
import { ReactComponent as EvaluateHabit3 } from './achievements/bages/evaluateHabit/3.svg';
import { ReactComponent as EvaluateHabit4 } from './achievements/bages/evaluateHabit/4.svg';
import { ReactComponent as EvaluateHabit5 } from './achievements/bages/evaluateHabit/5.svg';
import { ReactComponent as BadgeLocked } from './achievements/bages/locked.svg';
import { ReactComponent as SelectUserIcon } from './SelectUserIcon.svg';

// Small icons
import { ReactComponent as PersonIcon } from './smallIcons/PersonIcon.svg';
import { ReactComponent as FingerUpIcon } from './smallIcons/FingerUpIcon.svg';
import { ReactComponent as ChatIcon } from './smallIcons/ChatIcons.svg';
import { ReactComponent as KPIIcon } from './smallIcons/KPIIcon.svg';
import { ReactComponent as CalendarIcon } from './smallIcons/CalendarIcon.svg';
import { ReactComponent as ChartIcon } from './smallIcons/ChartIcon.svg';
import { ReactComponent as DollarIcon } from './smallIcons/DollarIcon.svg';
import { ReactComponent as StampIcon } from './smallIcons/StampIcon.svg';
import { ReactComponent as SmileIcon } from './smallIcons/SmileIcon.svg';
import { ReactComponent as UsersIcon } from './smallIcons/UsersIcon.svg';
import { ReactComponent as AtsignIcon } from './smallIcons/AtsignIcon.svg';
import { ReactComponent as MicroActionChallengeIcon } from './MicroActionChallengeIcon.svg';
import { ReactComponent as AppreciationIcon } from './AppreciationIcon.svg';
import { ReactComponent as EndOfActionHabitIcon } from './EndOfActionHabitIcon.svg';
import { ReactComponent as RankOneIcon } from './RankOneIcon.svg';
import { ReactComponent as RankIcon } from './RankIcon.svg';
import { ReactComponent as TeamLeaderboardIcons } from './TeamLeaderboardIcons.svg';
import { ReactComponent as TimeLineBlueIcon } from './TimeLineBlueIcon.svg';

// Mood icons
import { ReactComponent as MoodAwfulIcon } from './mood/MoodAwfulIcon.svg';
import { ReactComponent as MoodNotGoodIcon } from './mood/MoodNotGoodIcon.svg';
import { ReactComponent as MoodFineIcon } from './mood/MoodFineIcon.svg';
import { ReactComponent as MoodGoodIcon } from './mood/MoodGoodIcon.svg';
import { ReactComponent as MoodGreatIcon } from './mood/MoodGreatIcon.svg';

export const IconMap = {
  BlueArrowRight,
  Logo,
  DevelopBehaviours,
  KeepTrackIcon,
  BringCulture,
  CrossIcon,
  GreenCheckIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  LoginSidebarImg,
  WhiteLogo,
  OneIcon,
  TwoIcon,
  ThreeIcon,
  FourIcon,
  GreenCheckIcon2,
  BlueCheckedIcon,
  PlusIcon,
  PositiveImpactIcon,
  KeepGoingBlueIcon,
  KeepGoingGreyIcon,
  CheckedBlueIconCircle,
  NotCheckedBlueIcon,
  KeepDoingSmallIcon,
  LeaderboardIcon,
  TreeDotsIcon,
  CheckedGreenIconCircle,
  NotCheckedGrayIconCircle,
  GreenUpIcon,
  NeutralArrowIcon,
  IconDown,
  GreyChartIcon,
  GreyCalendarIcon,
  NoTasksIcon,
  QuickQuizIcon,
  DailyReflectionIcon,
  PulseCheckIcon,
  MythFactIcon,
  ClockIcon,
  LogoutIcon,
  ArrowRightIcon,
  SummaryMoodIcon,
  SummaryAchievementsIcon,
  SummaryTeamIcon,
  GreenUpWithBGIcon,
  GreenIconsUpRight,
  RedDownWithBGIcon,
  NeutralWithBGIcon,
  BlackArrowUp,
  BlackArrowDown,
  BlackArrowRight,
  Achievement1Icon,
  Achievement2Icon,
  Achievement3Icon,
  Achievement4Icon,
  ProgrammIcon1,
  ProgrammIcon2,
  ProgrammIcon3,
  // Milestones
  MilestonesLevel1,
  MilestonesLevel2,
  MilestonesLevel3,
  MilestonesLevel4,
  // Peers Endorsement
  PeersEndorsement1,
  PeersEndorsement2,
  PeersEndorsement3,
  PeersEndorsement4,
  PeersEndorsement5,
  // Streak
  Streak3,
  Streak5,
  Streak7,
  Streak10,
  Streak15,
  // Habit Development
  HabitDev2,
  HabitDev5,
  HabitDev10,
  HabitDev15,
  HabitDev30,
  // Evaluate Habit
  EvaluateHabit1,
  EvaluateHabit2,
  EvaluateHabit3,
  EvaluateHabit4,
  EvaluateHabit5,
  BadgeLocked,
  // Select icon
  SelectUserIcon,
  // Small icons
  PersonIcon,
  FingerUpIcon,
  ChatIcon,
  KPIIcon,
  CalendarIcon,
  ChartIcon,
  DollarIcon,
  StampIcon,
  SmileIcon,
  UsersIcon,
  AtsignIcon,
  // Action type icons
  MicroActionChallengeIcon,
  AppreciationIcon,
  EndOfActionHabitIcon,
  BehaviourReversalIcon,
  MiniLearningPromptIcon,
  PatternRecognitionIcon,
  ScenarioIcon,
  NotCheckedGrayFullIconCircle,
  RankOneIcon,
  RankIcon,
  TeamLeaderboardIcons,
  TimeLineBlueIcon,
  // Mood
  MoodAwfulIcon,
  MoodNotGoodIcon,
  MoodFineIcon,
  MoodGoodIcon,
  MoodGreatIcon,
} as const;


export type IconName = keyof typeof IconMap;

interface IconProps {
  iconName: IconName;
  width?: string | number;
  height?: string | number;
  color?: string;
  hover?: boolean;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ iconName, width, height, color, hover, className }) => {
  const IconComponent = IconMap[iconName];
  if (!IconComponent) {
    return null;
  }
  return (
    <IconComponent
      width={width ?? '1.25rem'}
      height={height ?? '1.25rem'}
      style={{ '--icon-color': color } as React.CSSProperties}
      className={className}
    />
  );
};
